<section class="container">

  <header class=" bg-gradient-to-b from-base-300 to-base-100 p-4 rounded-2xl mb-4 flex flex-col sm:flex-row gap-3 md:block justify-between items-center">
    <h1 class="text-6xl font-heading mb-4 text-primary/90 text-shadow-md">Movies</h1>
    <app-filter-model class="md:hidden block w-full sm:w-fit *:w-full " [type]="'movies'"></app-filter-model>
  </header>
  <div class="flex sm:flex-row flex-col my-3 gap-3  min-h-screen">
    <!-- filteration section -->
    <div><app-filter class="md:w-full md:block hidden md:sticky top-30" [type]="'movies'"></app-filter></div>
    <div class="movies-content md:w-4/5 w-full flex flex-col justify-center items-center">

      @if(loading)
      {
      <div class="min-h-screen flex justify-center items-center w-full bg-black/20 dark:bg-black/85  rounded-2xl">
        <span class="loading loading-spinner text-primary"></span>
      </div>
      }
      @else {
      <div class="w-full grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 flex-1">

        @if(!filterFlag)
        {
        <div *ngFor="let movie of pageMovies; let i = index">
          <!-- Calling Movie Card here & pass Movie Object -->
          <app-mediaCard class="*:mx-auto" [mediaItem]="movie"></app-mediaCard>
        </div>
        }
        @else {
        @if(totalFilteredPages){
        <div *ngFor="let movie of filteredPageMovies; let i = index">
          <!-- Calling Movie Card here & pass Movie Object -->
          <app-mediaCard class="*:mx-auto" [mediaItem]="movie"></app-mediaCard>
        </div>
        }
        @else {
        <div class="min-h-screen flex justify-center items-center w-full bg-black/20 dark:bg-black/85  rounded-2xl">
          <h2 class="text-lg text-primary">No Matching Results</h2>
        </div>
        }

        }


      </div>
      }



      <div class="container md:w-1/3 w-1/2  mt-4">
        <div class="join mx-auto">
          <button (click)="previousPageContent()" class="join-item btn">«</button>
          @if(!filterFlag)
          {
          <button class="join-item btn">Page {{currentPage}}</button>
          }
          @else {
          <button class="join-item btn">Page {{currentFilteredPage}}</button>
          }

          <button (click)="nextPageContent()" class="join-item btn">»</button>
        </div>
      </div>

    </div>
  </div>



</section>
